import { i18n } from "@/i18n"
import { getItem } from "@/utils/gameAssets"

export const RECALL_REWARD_MAP: Record<
    string,
    {
        key: string
        src: string
        title: string
        amount: number
        order: number
        type: "virtual" | "real"
    }
> = {
    "voucher_levelmax_6": {
        key: "voucher_levelmax_6",
        src: getItem("voucher_levelmax_6"),
        title: i18n.getRecall("reward.voucher_levelmax_6"),
        amount: 1,
        order: 1,
        type: "virtual",
    },
    "voucher_skill_specialLevelMax_6": {
        key: "voucher_skill_specialLevelMax_6",
        src: getItem("voucher_skill_specialLevelMax_6"),
        title: i18n.getRecall("reward.voucher_skill_specialLevelMax_6"),
        amount: 1,
        order: 2,
        type: "virtual",
    },
    "voucher_levelmax_5": {
        key: "voucher_levelmax_5",
        src: getItem("voucher_levelmax_5"),
        title: i18n.getRecall("reward.voucher_levelmax_5"),
        amount: 1,
        order: 3,
        type: "virtual",
    },
    "voucher_skill_specialLevelMax_5": {
        key: "voucher_skill_specialLevelMax_5",
        src: getItem("voucher_skill_specialLevelMax_5"),
        title: i18n.getRecall("reward.voucher_skill_specialLevelMax_5"),
        amount: 1,
        order: 4,
        type: "virtual",
    },
    "voucher_chipPackage": {
        key: "voucher_chipPackage",
        src: getItem("voucher_chipPackage"),
        title: i18n.getRecall("reward.voucher_chipPackage"),
        amount: 1,
        order: 5,
        type: "virtual",
    },
    "advanced_material_issue_voucher": {
        key: "advanced_material_issue_voucher",
        src: getItem("advanced_material_issue_voucher"),
        title: i18n.getRecall("reward.advanced_material_issue_voucher"),
        amount: 8,
        order: 6,
        type: "virtual",
    },
    "4001": {
        key: "4001",
        src: getItem("4001"),
        title: i18n.getRecall("reward.4001"),
        amount: 10000,
        order: 7,
        type: "virtual",
    },
}
